<img [src]="'assets/images/svgs/' + getSort() + '.svg'" alt="" /> Sort by {{ getSort() }}
